import "core-js/actual/iterator"
import "./jquery"
import "./controllers"

window.dispatchMapsEvent = function (...args) {
    const event = document.createEvent("Events")
    event.initEvent("google-maps-callback", true, true)
    event.args = args
    window.dispatchEvent(event)
}

document.addEventListener("DOMContentLoaded", (event) => {
    console.log("DOM fully loaded and parsed");
    // document.querySelector(" INPUT[type='text']")?.focus();
});